import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import { UntypedFormControl, Validators } from '@angular/forms';
import { AiService } from 'src/app/api/services';
import {
  AiQuestionEvaluation,
  AiQuestionEvaluationResult,
} from 'src/app/api/models';
import { ContentSpinnerComponent } from '../../ui/content-spinner.component';
import { MatIcon } from '@angular/material/icon';
import { NgTemplateOutlet } from '@angular/common';
import { FormInputComponent } from '../../form-field/input.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import { generateScoreSteps } from 'src/app/utility/app.utils';
import { TrackingService } from 'src/app/utility/amplitude-tracking/tracking.service';

@Component({
  selector: 'qa-import-ai-explanation',
  templateUrl: './import-ai-explanation.component.html',
  styleUrls: ['./import-ai-explanation.component.scss'],
  imports: [
    ContentSpinnerComponent,
    MatDialogClose,
    MatIcon,
    NgTemplateOutlet,
    FormInputComponent,
    ButtonComponent,
    TranslateModule,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
  ],
})
export class ImportAiExplanationComponent implements OnInit {
  explanation = new UntypedFormControl(null, Validators.required);
  generatedQuestionResult: AiQuestionEvaluationResult;
  scoreSteps: number[] = [];
  score: number;
  loading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AiQuestionEvaluation,
    public dialogRef: MatDialogRef<AiQuestionEvaluation>,
    private trackingService: TrackingService,
    private translator: TranslateService,
    private matSnackBar: MatSnackBar,
    private aiService: AiService
  ) {}

  ngOnInit(): void {
    this.generateAIQuestions();
    this.scoreSteps = generateScoreSteps(this.data?.max_score ?? 0);
  }

  generateAIQuestions() {
    this.aiService
      .evaluateQuestion({
        body: this.data,
      })
      .subscribe({
        next: (data) => {
          this.trackingService.trackAIEvaluationEvent(1);
          this.generatedQuestionResult = data;
          this.score = data.evaluation_result;
          this.explanation.setValue(this.generatedQuestionResult.feedback);
          this.loading = false;
        },
        error: () => {
          this.matSnackBar.open(
            this.translator.instant('AIQuestionImports.errorToast')
          );
        },
      });
  }

  importAIQuestions() {
    this.dialogRef.close({
      feedback: this.explanation.value,
      score: this.score,
    });
  }
}
